import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const sandboxState = (state: RootState) => state.scene.settings.sandbox;

export const doesIntegrationExist = createSelector(
  sandboxState,
  ({ hasIntegration }) => hasIntegration
);

export const isSandboxLoading = createSelector(sandboxState, ({ loading }) => loading);
